import Vue from "vue";
import Router from "vue-router";
import NoFound from "./views/404";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  base:"/",
  routes: [
    {
      path: "*",
      name: "/404",
      component: NoFound
    },
    {
      path: "/",
      redirect: "/index"
    },
    /*默认官网首页 */
    {
      path: "/index",
      name: "首页",
      component: () => import("./views/home/home.vue")
    },
    /*build生成*/
    {
      path: "/build",
      name: "build",
      component: () => import("./views/build/build.vue")
    },
    /*newbuild生成*/
    {
      path: "/newbuild",
      name: "newbuild",
      component: () => import("./views/newbuild/newbuild.vue")
    },
  ]
});